import { motion } from 'framer-motion';
import { 
  HomeIcon,
  BuildingOfficeIcon,
  BuildingStorefrontIcon,
  ShoppingBagIcon,
  InboxStackIcon,
  EllipsisHorizontalCircleIcon
} from '@heroicons/react/24/outline';
import { H2, BodyLarge } from '../ui/Typography';

const assetClasses = [
  { icon: HomeIcon, title: 'Single-Family' },
  { icon: BuildingOfficeIcon, title: 'Multifamily' },
  { icon: BuildingStorefrontIcon, title: 'Hotel' },
  { icon: ShoppingBagIcon, title: 'Retail' },
  { icon: InboxStackIcon, title: 'Self-Storage' },
  { icon: EllipsisHorizontalCircleIcon, title: 'And More' }
];

export default function RealEstateMadeSimple() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <H2 className="text-primary mb-8">Real Estate Made Simple</H2>
          <BodyLarge className="text-gray-600 max-w-3xl mx-auto">
            RentFi investors earn both the RENT tokens value appreciation and the revenue from the assets without the fiduciary or legal liability of ownership.
          </BodyLarge>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {assetClasses.map((asset, index) => (
            <motion.div
              key={asset.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group"
            >
              <div className="bg-gray-50 rounded-lg p-8 text-center h-full flex flex-col items-center justify-center transition-transform duration-300 group-hover:-translate-y-1">
                <asset.icon className="w-12 h-12 text-secondary mb-4" />
                <h4 className="text-gray-900 mb-3 font-kanit text-[22px] leading-[36px]">{asset.title}</h4>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}